import { Button, Icon } from "@sagot/ui";
import { useState } from "react";
import type { HandoffOfferPayload } from "../types";

export interface HandoffOfferCardProps {
  payload: HandoffOfferPayload;
  onAccept: () => void;
  onAskElse: () => void;
  labels?: { accept?: (team: string) => string; askElse?: string };
}

/** Knowledge-gap fallback: forward to staff, or ask something else. Buttons disappear after accepting. */
export function HandoffOfferCard({ payload, onAccept, onAskElse, labels }: HandoffOfferCardProps) {
  const [accepted, setAccepted] = useState(false);
  if (accepted) return null;
  return (
    <div className="mt-2 flex flex-wrap gap-1.5">
      <Button
        variant="secondary"
        size="sm"
        className="min-h-11"
        onClick={() => {
          setAccepted(true);
          onAccept();
        }}
      >
        <Icon name="headset" />
        {labels?.accept?.(payload.team) ?? `Yes, forward to ${payload.team}`}
      </Button>
      <Button variant="ghost" size="sm" className="min-h-11" onClick={onAskElse}>
        {labels?.askElse ?? "Ask something else"}
      </Button>
    </div>
  );
}
